import React from 'react'
import './css/landing.css'

export default function Landing() {
  return (
    <div className="position-relative" style={{ height: '100vh' }}>
      <img 
        src="./images/landing.jpg"
        alt="Hero"
        className="w-100 h-100 object-fit-cover"
      />
      <div className="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-end" 
           style={{ background: 'linear-gradient(to top, rgba(0,0,0,0.6), transparent)' }}>
        <div className="container pb-5">
          <div className="row">
            <div className="col-12 col-lg-8">
              <span className="text-white-50 text-uppercase small letter-spacing-2">Editor's Pick</span>
              <h1 className="display-4 text-white mt-2 mb-3 fw-bold font-serif">
                The Evolution of Business: Looking Back at 2024's Defining Moments
              </h1>
              <p className="text-white-75 lead">
                From runway revelations to street style revolutions, we explore the year's most impactful fashion statements.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
 
  )
}
